import axios from 'axios';
import { API_END_POINT } from 'configs/configs';
import AuthUser from './auth';

class Calendar {
  /* send Request to the API endpoint
   *   return request promise
   */
  async sendRequest({endpoint, params = null,data = null, method = 'GET'}) {
    try {
      let currentUserToken = AuthUser.getToken();
      let response = await axios({
        // Endpoint to send files
        url: endpoint,
        method: method,
        params,
        data,
        headers: {
          'Content-Type': 'application/json',
          authorization: `Bearer ${currentUserToken}`,
        },
      });
     
      if (Number(response.data.error) !== 0 && response.data.error!== undefined) {
        return Promise.reject(response);
      }
   
      return Promise.resolve(response.data);
    } catch (error) {
      return Promise.reject(error);
    }
  }

 
 
  /*
   * Get weekends days
   */
  async getWeekends(){
    return this.sendRequest({endpoint:API_END_POINT.CALENDAR_WEEKENDS});
  }

  /*
  * @param <Object<array>> weekends 
  */
  async changeWeekends(weekends){
    return this.sendRequest({endpoint:API_END_POINT.CALENDAR_WEEKENDS,data:weekends,method:'POST'});
  }
}

const CalendarSettings = new Calendar();
export default CalendarSettings;
